// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__dYTEm","spin":"Spinner_spin__wEDl_"};